import React, { Component } from "react";
import "scss/components/modals/deviceData/machineModal.scss";
import { Form, Icon, Modal, Table} from "semantic-ui-react";


export default class MachineModal extends Component {
  createActiveTime = (data) => {
    if (data === undefined) {
      return;
    }
    const newData = data.split(":");
    let hr = "";
    let min = "";
    if (newData[0] !== "0") {
      hr = `${newData[0]} ชั่วโมง `;
    }
    if (newData[1] !== "0") {
      min = `${newData[1]} นาที `;
    }
    return `${hr}${min}${newData[2]} วินาที`;
  };

  formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // เดือนจะเริ่มนับจาก 0
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  render() {
    const deviceDetail = this.props.data;
    const dataHitory = this.props.dataHitory;
    console.log("dataHitorys", dataHitory);
    return (
      <Modal
        closeIcon
        dimmer="blurring"
        open={this.props.isOpen}
        onClose={() => this.props.isClose()}
      >
        <Modal.Header>
          <Icon name="archive" />
          &ensp;ข้อมูลเครื่องจักร (ผู้ใช้งานล่าสุด)
        </Modal.Header>
        <Modal.Content className="machine">
          <table>
            <tbody>
              <tr>
                <td>หมายเลขเครื่องจักร</td>
                <td>
                  <Form.Input
                    placeholder="หมายเลขเครื่องจักร"
                    value={deviceDetail.clp_serial}
                  />
                </td>
              </tr>
              <tr>
                <td>หมายเลขอุปกรณ์ IoT</td>
                <td>
                  <Form.Input
                    placeholder="หมายเลขอุปกรณ์ IoT"
                    value={deviceDetail.device_serial}
                    readOnly
                  />
                </td>
              </tr>
              <tr>
                <td>ชื่อผู้ใช้งาน</td>
                <td>
                  <Form.Input
                    placeholder="ชื่อผู้ใช้งาน"
                    value={deviceDetail.username}
                  />
                </td>
              </tr>
              <tr>
                <td>วันที่เริ่มใช้งาน</td>
                <td>
                  <Form.Input
                    placeholder="วันที่เริ่มใช้งาน"
                    format="DD-MM-YYYY"
                    value={this.formatDate(deviceDetail.devicebuy_date)}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </Modal.Content>

        <Modal.Header>
          <Icon name="history" />
          &ensp;ประวัติการผูกเครื่องจักร
        </Modal.Header>

        <Table celled striped selectable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell className="blue-header">NO</Table.HeaderCell>
              <Table.HeaderCell className="blue-header">User ID</Table.HeaderCell>
              <Table.HeaderCell className="blue-header">วันที่เริ่มใช้งาน</Table.HeaderCell>
              <Table.HeaderCell className="blue-header">วันที่ยกเลิกการใช้งาน</Table.HeaderCell>
              <Table.HeaderCell className="blue-header">สถานะการใช้งาน</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {dataHitory?.map((device, idx) => (
              <Table.Row key={idx}>
                <Table.Cell>{idx + 1}</Table.Cell>
                <Table.Cell>{device.username}</Table.Cell>
                <Table.Cell>{this.formatDate(device.devicebuy_date)}</Table.Cell>
                <Table.Cell>{this.formatDate(device.update_date)}</Table.Cell>
                <Table.Cell>{device.is_delete === 1 ? "ยกเลิกแล้ว" : "ใช้งาน"}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>

        </Table>
      </Modal>
    );
  }
}
